/** @format */

export const ShieldMedium = ({color}) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#a99j7z4uua)">
                <path
                    d="M21 11c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12V5l9-4 9 4v6zm-9 10c3.75-1 7-5.46 7-9.78V6.3l-7-3.12L5 6.3v4.92C5 15.54 8.25 20 12 21zm2.8-10V9.5C14.8 8.1 13.4 7 12 7S9.2 8.1 9.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="a99j7z4uua">
                    <path fill={color} d="M0 0h24v24H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
